import { Toaster as Sonner, type ToasterProps } from "sonner";

/** Where toasts sit; an app moves them clear of its own fixed controls. */
export type ToasterPlacement = Pick<ToasterProps, "position" | "offset" | "mobileOffset">;

export function Toaster({ theme = "light", ...placement }: { theme?: "light" | "dark" } & ToasterPlacement) {
  return (
    <Sonner
      theme={theme}
      position="bottom-right"
      offset={16}
      duration={4200}
      closeButton
      {...placement}
      toastOptions={{
        classNames: {
          toast: "font-body",
          title: "text-sm font-medium",
          description: "text-sm text-[var(--text-secondary)]",
        },
      } satisfies ToasterProps["toastOptions"]}
    />
  );
}
